import { forwardRef } from 'react';
import type { SVGProps, Ref } from 'react';
type Props = SVGProps<SVGSVGElement>;
/**
 * @public
 */
const SvgStepSmallDone = forwardRef(
  (props: Props, svgRef: Ref<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={20}
      fill="none"
      viewBox="0 0 16 20"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#084"
        d="M13.318 4.295a.97.97 0 011.393 0c.358.366.383.942.077 1.338l-.077.088L5.64 15 .289 9.528a1.024 1.024 0 010-1.425.97.97 0 011.307-.079l.086.079 3.956 4.046 7.68-7.854z"
      />
    </svg>
  )
);
SvgStepSmallDone.defaultProps = {
  'aria-hidden': true,
  focusable: 'false',
  role: 'img',
};
export default SvgStepSmallDone;
